<button
  class="nav-link btn-route-access-logs"
  type="button"
  data-bs-toggle="dropdown"
  aria-expanded="false"
  (click)="refreshCurrentUrlLogs()"
  >
  <fa-icon [icon]="faHistory"></fa-icon>
</button>
<div class="dropdown-menu dropdown-menu-end">
  <div class="dropdown-item-text route-access-logs-title">
    {{ "USERS.CURRENT_URL_ACCESS_LOGS" | translate }}
  </div>
  <div class="dropdown-item-text route-access-logs-current-path" [title]="getCurrentRoutePath()">
    {{ getCurrentRoutePath() }}
  </div>

  @if (loadingCurrentUrlLogs) {
    <ul class="list-group list-group-flush route-access-logs-list">
      @for (number of [].constructor(5); track $index) {
        <li class="list-group-item placeholder-glow">
          <div class="placeholder w-100"></div>
        </li>
      }
    </ul>
  }

  @if (!loadingCurrentUrlLogs) {
    <ul
      class="list-group list-group-flush route-access-logs-list"
      (scroll)="onLogsListScroll($event)"
      >
      @if (currentUrlLogsError) {
        <li class="list-group-item list-group-item-danger text-center">
          {{ currentUrlLogsError }}
        </li>
      }
      @if (!currentUrlLogsError && !currentUrlLogs.length) {
        <li
          class="list-group-item list-group-item-warning text-center"
          >
          {{ "USERS.NO_CURRENT_URL_ACCESS_LOGS" | translate }}
        </li>
      }
      @for (eventLog of currentUrlLogs; track trackByLogId($index, eventLog)) {
        <button
          type="button"
          class="list-group-item list-group-item-action route-access-log-item"
          (click)="openRouteAccessLogDetails(eventLog)"
          >
          <div class="route-access-log-user-row">
            <div class="route-access-log-user">{{ getUserDisplayName(eventLog.userId) }}</div>
            @if (isCurrentUserCurrentSessionLog(eventLog)) {
              <span
                class="badge text-bg-success route-access-log-current-user-badge"
                >
                {{ "USERS.CURRENT_SESSION_BADGE" | translate }}
              </span>
            }
          </div>
          <div class="route-access-log-date">
            @if (getEventTimestamp(eventLog); as eventTimestamp) {
              {{ eventTimestamp | date: "dd/MM/yyyy HH:mm:ss" }}
            } @else {
              {{ "GENERAL.UNKNOWN" | translate }}
            }
          </div>
          @if (getEventPageDurationLabel(eventLog); as durationLabel) {
            <div
              class="route-access-log-duration"
              >
              {{ "USERS.TIME_ON_PAGE" | translate }}: {{ durationLabel }}
            </div>
          }
        </button>
      }
      @if (loadingMoreCurrentUrlLogs) {
        <li class="list-group-item text-center">
          {{ "GENERAL.LOADING" | translate }}
        </li>
      }
    </ul>
  }
</div>
